import React, { useState } from "react";
import { Circles } from "react-loader-spinner";
import { DocumentUploadIcon } from "asset/icons";
import markSuccess from "asset/images/marksuccess.svg";
import SampleDocumentModal from "./SampleDocumentModal";

const UploadInputField = ({
    label,
    subtitle,
    fileKey,
    fileState,
    onFileChange,
    onRemove,
    seeSampleDoc,
    seeSampleTabs = [],
    inputBg = "#f1f5f9",
    uploadedBg = "#f1f5f9",
    iconBg = "#DCCBFF",
    titleColor = "#161827",
    subtitleColor = "#9396B4",
    disabled = false,
    uploadTitle = "Upload document",
    hideLabel = false,
    validationError = "",
}) => {
    const { file, loading, uploaded, progress } = fileState;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(seeSampleTabs.length > 1 ? seeSampleTabs[0] : "");

    return (
        <div className="space-y-1 w-full">
            {/* Top Label and See Sample Link */}
            {(!hideLabel || seeSampleDoc) && (
                <div className="flex items-center justify-between">
                    {!hideLabel && (
                        <p className="aku-body-small-medium text-[#4F5372]">{label}</p>
                    )}
                {seeSampleDoc && (
                    <span
                        className="text-[#6F00FF] text-base font-normal flex gap-1 items-center cursor-pointer"
                        onClick={() => setIsModalOpen(true)}
                    >
                        See sample <span className="material-icons">chevron_right</span>
                    </span>
                )}
                </div>
            )}

            {/* Whole Box as Clickable Label */}
            <label
                htmlFor={disabled ? undefined : fileKey}
                className={`w-full rounded-lg flex items-center justify-between gap-3 px-4 !py-5 ${
                    disabled ? "" : "cursor-pointer"
                } ${validationError ? "ring-1 ring-[#F04438]" : ""}`}
                style={{
                    backgroundColor: validationError
                        ? "#FFF1F3"
                        : disabled
                          ? "#F8FAFC"
                        : uploaded || loading || file
                          ? uploadedBg
                          : inputBg,
                }}
            >
                {/* LEFT SECTION */}
                <div className="flex items-center gap-3">
                    {loading ? (
                        <div className="w-5 h-5 flex items-center justify-center">
                            <Circles height="20" width="20" color="#6F00FF" />
                        </div>
                    ) : uploaded ? (
                        <img src={markSuccess} alt="Uploaded" className="w-5 h-5" />
                    ) : (
                        <span className="rounded-full p-2" style={{ backgroundColor: iconBg }}>
                            <DocumentUploadIcon />
                        </span>
                    )}

                    <div className="flex flex-col">
                        {loading ? (
                            <p className="text-sm text-[#344054]">Uploading... {progress}%</p>
                        ) : uploaded && file ? (
                            <>
                                <p className="text-sm text-[#344054]">{file.name}</p>
                                <p className="text-xs text-[#667085]">
                                    {(file.size / (1024 * 1024)).toFixed(1)} MB
                                </p>
                            </>
                        ) : (
                            <>
                                <p
                                    className="text-base font-[500]"
                                    style={{ color: titleColor }}
                                >
                                    {uploadTitle}
                                </p>
                                <p
                                    className="text-sm font-[400]"
                                    style={{ color: subtitleColor }}
                                >
                                    JPEG, PNG, JPG, PDF ・ 5 MB max.
                                </p>
                            </>
                        )}
                    </div>
                </div>

                {/* RIGHT SECTION: Remove or Upload */}
                <div className="flex-shrink-0">
                    {uploaded && !disabled ? (
                        <span
                            onClick={(e) => {
                                e.preventDefault();
                                onRemove();
                            }}
                            className="material-icons cursor-pointer text-[#98A2B3]"
                        >
                            delete
                        </span>
                    ) : loading ? (
                        <span
                            onClick={(e) => {
                                e.preventDefault();
                                onRemove();
                            }}
                            className="material-icons cursor-pointer text-[#98A2B3]"
                        >
                            close
                        </span>
                    ) : null}
                </div>

                {/* HIDDEN FILE INPUT */}
                <input
                    type="file"
                    id={fileKey}
                    className="hidden"
                    accept=".jpeg, .jpg, .png, .pdf"
                    onChange={onFileChange}
                    disabled={disabled}
                />
            </label>
            {validationError && (
                <p className="text-xs text-[#D92D20]">{validationError}</p>
            )}

            {/* Modal for Document Sample */}
            <SampleDocumentModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title={label}
                tabs={seeSampleTabs}
                activeTab={activeTab}
                onTabChange={setActiveTab}
                documentSrc={seeSampleDoc}
            />
        </div>
    );
};

export default UploadInputField;
